import PropTypes from 'prop-types';
import { SIZES } from '../base-select/constants';
import { GROUP_OPTION_TYPE, OPTION_TYPE } from '../base-select/types';

export const SEARCHABLE_SELECT_PROPS = {
  size: PropTypes.oneOf(Object.values(SIZES)),
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  noResultsText: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(GROUP_OPTION_TYPE), PropTypes.shape(OPTION_TYPE)])
  ),
  defaultValue: PropTypes.shape(OPTION_TYPE),
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  preventOverflow: PropTypes.bool,
  openMenuOnFocus: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onInputChange: PropTypes.func,
  filterOptionsFunction: PropTypes.func,
  asyncConfig: PropTypes.shape({
    loadOptions: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    cacheOptions: PropTypes.oneOfType([PropTypes.shape(), PropTypes.bool]),
    defaultOptions: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.shape(GROUP_OPTION_TYPE), PropTypes.shape(OPTION_TYPE)])
      ),
    ]),
  }),
  menuPlacement: PropTypes.oneOf(['auto', 'bottom', 'top']),
  maxMenuHeight: PropTypes.number,
};
